module.exports = __webpack_public_path__ + "static/flag-of-brazil-6f95850b36c3223f212c4cb7746138d3.svg";